export default function Footer() {
  return (
    <footer className="mt-auto">
      <hr />
      <div>
        <span className="attention">*</span> - no country assigned
      </div>
      <div>
        1 - CET: <b>c</b>hange <b>e</b>mail <b>t</b>ypes
      </div>
    </footer>
  );
}
